export default __webpack_public_path__ + "static/media/loc.63c84455.png";